import { replaceParameters } from '@/common-utils/functions/restUtils';
import { client } from '../../../../../common-utils/libraries/axios/axios';
import { POS_TERMINALS } from '../apiUrls';

const mutationRewarehousePosTerminal = (onSuccess, onError) => {
    return {
        mutationFn: ({ subscriptionId }) => {
            return client.post(replaceParameters(POS_TERMINALS.IN_STOCK.url, { subscriptionId: subscriptionId }));
        },
        // onError: (error, variables, context)
        onError: (error) => {
            onError(error);
        },
        // onSuccess: (data, variables, context)
        onSuccess: () => {
            onSuccess();
        },
        // onSettled: (data, error, variables, context)
        onSettled: () => {
            // Error or success... doesn't matter!
        }
    };
};

export default mutationRewarehousePosTerminal;